import pt_BR from '../../date-picker/locale/pt_BR';
export default pt_BR;



// WEBPACK FOOTER //
// ./components/calendar/locale/pt_BR.tsx